import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';
import styled from 'styled-components';
import device from '../mediaQueries';
import TrackingEvents from '../../common/models/TrackingEvents';
import withCountryCode from '../RoutesHoc/RoutesHoc';

const LogoImgStyled = styled.img`
  ${({ width }) => `width: ${width || '61px'};`}
  ${({ height }) => `height: ${height || '25px'};`}
  ${device.desktop`
    ${({ width }) => `width: ${width || '101px'};`}
    ${({ height }) => `height: ${height || '40px'};`}
 `}
  ${({ margin }) => (margin ? `margin: ${margin};` : null)}
`;

export const LogoImg = ({ s3BasePath, margin, width, height }) => (
  <LogoImgStyled
    alt="Luxury Italian Fashion Boutique: clothes, shoes, bags | italist"
    src={`${s3BasePath}mkt/logo_small.png`}
    margin={margin}
    width={width}
    height={height}
  />
);

class Logo extends Component {
  componentDidMount() {
    mixpanel.track_links('#logo-img', TrackingEvents.logoClicked());
  }

  render() {
    const { s3BasePath, buildUrlWithCountry } = this.props;
    return (
      <h1 id="logo">
        <a
          id="logo-img"
          href={buildUrlWithCountry()}
          title="italist - Luxury Italian Fashion Boutique: clothes, shoes, bags | italist"
        >
          <LogoImg s3BasePath={s3BasePath} />
        </a>
      </h1>
    );
  }
}

Logo.propTypes = {
  s3BasePath: PropTypes.string.isRequired,
  buildUrlWithCountry: PropTypes.func.isRequired
};

export default withCountryCode(Logo);
